import { Box, Icon, styled } from '@worthy-npm/worthy-common-ui-components';
import React from 'react';

const Lines = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_18621_18752)">
      <path d="M0.00195312 1.89648H15.9512" stroke="#2C4EB5" strokeWidth="3" />
      <path d="M0.00195312 11.9805H24.002" stroke="#2C4EB5" strokeWidth="3" />
      <path d="M-0.00390625 22.1035H23.9961" stroke="#2C4EB5" strokeWidth="3" />
    </g>
    <defs>
      <clipPath id="clip0_18621_18752">
        <rect width="24.0059" height="24" fill="white" transform="translate(-0.00390625)" />
      </clipPath>
    </defs>
  </svg>,
  '3lines',
);

const Star = Icon.createSvgIcon(
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8406 1C14.131 7.0089 18.8344 11.697 24.8475 12.9678L25 13L24.8475 13.0322C18.8344 14.303 14.131 18.9911 12.8406 25L12.8079 24.8477C11.536 18.9246 6.91884 14.2918 1 13C6.91884 11.7082 11.536 7.07545 12.8079 1.1523L12.8406 1Z"
      stroke="#2C4EB5"
      strokeWidth="3"
    />
  </svg>,
  'star',
);

const TypeWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '386px',
  maxHeight: '318px',
  width: '100%',
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: '24px',
  gap: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    maxWidth: '312px',
    maxHeight: '233px',
    padding: theme.spacing(2),
    gap: theme.spacing(3),
  },
}));

const TextBoxWrapper = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  color: theme.palette.common.black,
  boxSizing: 'border-box',
  textAlign: 'center',
}));

export { TypeWrapper, Lines, TextBoxWrapper, Star };
